<template>
  <div>
    <b-card no-body header="Default" class="mb-0">
      <div slot="header">
        <div class="float-left">
          <div class="mt-2">
            <b> عنوان سوال </b>
            <span v-if="Object.keys(titleObject).length > 0">
              ({{ $lang.azmoonLang.identify }} :{{ titleObject.id }})
            </span>
          </div>
        </div>
        <div class="float-right">
          <b-button
            @click="openModal"
            v-b-tooltip.hover
            :title="$lang.add_title_tooltip"
            class="btn btn-lightgray ml-2 btn-secondary"
          >
            <i class="fa fa-list-alt" aria-hidden="true"></i>
          </b-button>
          <b-button @click="toggleCollapse" variant="success" class="ml-2">
            <i aria-hidden="true" class="fa fa-angle-down fa-lg"></i>
          </b-button>
          <b-button
            v-if="captionQuestion"
            class="ml-2"
            @click="removeTitle"
            v-b-tooltip.hover
            :title="$lang.remove"
            variant="danger"
          >
            <i class="fa fa-times" aria-hidden="true"></i>
          </b-button>
        </div>
      </div>
      <b-collapse v-model="isCollapse" class="mt-2">
        <b-col class="my-2" cols="12">
          <b-overlay
            no-center
            :variant="`transparent`"
            :blur="`2px`"
            :show="isOverlay"
            :opacity="0.3"
          >
            <template v-slot:overlay><span class="d-none">icon</span></template>
            <editor
              v-model="captionQuestion"
              @input="sendcaptionQuestion"
              resource="title"
              resourceId="0"
            ></editor>
          </b-overlay>
        </b-col>
      </b-collapse>
    </b-card>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="captionModal"
      size="xl"
      ok-only
      hide-header
    >
      <questionListTitle @optionSelected="valueTitle" />
      <template v-slot:modal-footer>
        <b-button
          variant="success"
          :disabled="captionQuestion ? false : true"
          @click="captionModal = false"
        >
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button class="ml-2" size="md" variant="danger" @click="cancelModal">
          {{ $lang.cancelButton }}
          <i class="fa fa-ban"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import questionListTitle from "./questionListTitle";
import editor from "@/components/ckeditor/editor";
import { createPureDom } from "@/shared/utils";

export default {
  validations: {
    answer_number: {},
  },
  props: {
    changePage: {
      type: Function,
      default: () => [],
    },
    allowPaginate: {
      type: Boolean,
      default: false,
    },
    question_kind: {
      type: [Number, String],
      required: true,
    },
  },
  inject: ["questionsTitleRepository"],
  components: {
    questionListTitle,
    editor,
  },
  data() {
    return {
      captionModal: false,
      isCollapse: true,
      selectedTitleText: null,
      isOverlay: false,
      questionkindLoading: false,
      answer_number: null,
      captionQuestion: "",
      titles: [],
      totalRows: 0,
      totalPages: 0,
      page: 1,
      perPage: null,
      isLoading: false,
      titleObject: {},
      searchValue: "",
    };
  },
  methods: {
    createPureDom,
    clear() {
      this.captionQuestion = "";
      this.answer_number = null;
    },
    sendcaptionQuestion(item) {
      this.$emit("selectedTitleText", item);
    },
    searchText(val) {
      if (val && val !== null) {
        this.searchValue = val;
        this.questionTitles();
      }
    },
    searchTextRemove(val) {
      if (this.searchValue) {
        this.searchValue = "";
        this.questionTitles();
      }
    },
    removeTitle() {
      this.isOverlay = false;
      this.captionQuestion = "";
      this.$emit("selectedTitleText", this.captionQuestion);
      this.$emit("getTitleID", this.captionQuestion);
    },
    valueTitle(item) {
      this.isOverlay = item.checked;
      this.captionQuestion = createPureDom(item.title_description);
      this.titleObject = item;
      let data = this.titles.map((x) => {
        if (x.id === item.id) {
          x.checked = true;
          return x;
        } else {
          x.checked = false;
          return x;
        }
      });
      this.titles = data;
    },
    openModal() {
      this.captionModal = true;
      this.page = 1;
      this.questionTitles();
    },
    async questionTitles() {
      let params = {
        page: this.page,
        search_txt: this.searchValue,
        is_enable: 1,
        order_by: "id:desc",
      };
      try {
        this.isLoading = true;
        const response = await this.questionsTitleRepository.list(params);
        const { result } = response.data.data;
        let data = response.data.data;
        if (result) {
          this.titles = result.map((x) => {
            if (x.id == this.titleObject.id) {
              return {
                ...x,
                checked: true,
              };
            } else {
              return {
                ...x,
                checked: false,
              };
            }
          });

          this.totalRows = data.total;
          this.totalPages = data.total_pages;
          this.perPage = data.per_page;
        }
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    cancelModal() {
      this.captionModal = false;
      this.isOverlay = false;
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    addCaption() {
      this.isCollapse = true;
    },
    paging(page) {
      this.page = page;
      this.questionTitles();
    },
  },
  watch: {
    captionQuestion(newVal) {
      this.captionQuestion = createPureDom(newVal);
    },
  },
  created() {},
};
</script>

<style></style>
